<template>
    <v-layout row>
        <v-flex xs12>
            <v-card color="#CCD5ED">
                <v-container class="reducedLineHeight" fluid grid-list-sm>
                    <v-layout row wrap>
                        <v-flex v-for="i in 16" :key="i" xs3 class="pa-2">
                            <product-intro :productIndex="i" @product-selected="triggerDialogProductDataInput"></product-intro>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import ProductIntro from "./DialogProductIntro";
    export default {
        name: "HomeContentGrid",
        data(){
            return {
                animationState: this.$store.getters['work/getAnimationState']
            }
        },
        computed: {
        },
        components: {ProductIntro},
        methods: {
            showProductIntro(i){
            },
            triggerDialogProductDataInput(selectedProductIndex){
                this.$store.dispatch("work/setDialogProductDataInputState",{
                    selectedProductIndex: selectedProductIndex,
                    show: true
                });
            }
        }
    }
</script>

<style>
    img {
        transition: all .5s ease-in-out;
    }

    img:hover, img:focus {
        background-color: #002EA7;
    }

.container.reducedLineHeight {
    line-height: 0.5em !important;
}

</style>
